import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import * as Constants from '@emi/shared/constants';
import { ConfigureDataComponent } from '@emi/shared/feature/configure-data';
import { clearFilters, clearSelections } from '@emi/shared/state/filters';
import { GenericModalComponent } from 'libs/shared/ui/src/lib/generic-modal/generic-modal.component';

@Injectable()
export class ConfigureDataCanDeactivateGuard implements CanDeactivate<ConfigureDataComponent> {
    constructor(private dialog: MatDialog) {}
    async canDeactivate(
        component: ConfigureDataComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Promise<boolean> {
        const showLeaveModal = JSON.parse(localStorage.getItem(component.modalType) ?? 'true');
        if (
            showLeaveModal &&
            nextState.url !== `/${Constants.Routes.FILTER_DATA_ROUTE}` &&
            nextState.url !== `/${Constants.Routes.SYSTEM_ERROR}` &&
            nextState.url !== `/${Constants.Routes.SKU_SEARCH_RESULTS}` &&
            nextState.url !== `/${Constants.Routes.SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE}`&&
            nextState.url !== `/${Constants.Routes.SAVE_AND_EXTRACT_ROUTE}`
        ) {
            const dialogRef = this.dialog.open(GenericModalComponent, {
                width: '340px',
                data: {
                    buttons: {
                        primary: 'Proceed',
                        secondary: 'Cancel',
                    },
                    content: 'Leaving will clear all your current selections, are you sure you want to leave?',
                    iconClass: 'fa-solid fa-triangle-exclamation',
                    title: 'Discard Current Selections',
                    type: component.modalType,
                    showUnderstoodCheckbox: true,
                },
            });

            return await dialogRef
                .afterClosed()
                .toPromise()
                .then((result) => {
                    if (result) {
                        component.dataExtractionStore.dispatch(clearFilters());
                        component.dataExtractionStore.dispatch(clearSelections());
                        return true;
                    }
                    return false;
                });
        }

        if (
            [
                `/${Constants.Routes.SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE}`,
                `/${Constants.Routes.FILTER_DATA_ROUTE}`,
                `/${Constants.Routes.SAVE_AND_EXTRACT_ROUTE}`,
                `/${Constants.Routes.SKU_SEARCH_RESULTS}`

            ].includes(nextState.url)
        ) {
            return true;
        }

        component.dataExtractionStore.dispatch(clearFilters());
        component.dataExtractionStore.dispatch(clearSelections());
        return true;
    }
}
